var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',[_c('v-tab',{attrs:{"to":{
      name: 'PatientRecordPAProgressStatus',
      params: {
        patientId: _vm.patientId,
      },
    }}},[_vm._v(" "+_vm._s(_vm.$ucfirst(_vm.$t("journeyBehaviourChangeGoals.status")))+" ")]),_c('v-tab',{attrs:{"to":{
      name: 'PatientRecordPAProgressProgress',
      params: {
        patientId: _vm.patientId,
      },
    }}},[_vm._v(" "+_vm._s(_vm.$ucfirst(_vm.$t("journeyProgress.progress")))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }